import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { db } from "../firebaseConfig";
import Comments from "./Comments";
import {
  doc,
  getDoc,
   setDoc,
   updateDoc,
  collection,
  query,
  where,
  getDocs,
   increment,
  limit
} from "firebase/firestore";

import {
  FaCalendarAlt,
  FaClock,
  FaFacebookF,
  FaWhatsapp,
  FaLinkedinIn,
  FaTelegramPlane
} from "react-icons/fa";

import { FaXTwitter } from "react-icons/fa6";
import "./MobileNewsDetails.css";

const MobileNewsDetails = () => {
  const { id } = useParams();
  const [openedIds, setOpenedIds] = useState([]);
  const [openedNews, setOpenedNews] = useState([]);
  const [news, setNews] = useState(null);
  const [relatedNews, setRelatedNews] = useState([]);
  const [inlineNewsMap, setInlineNewsMap] = useState({});
 
 
 const getRelatedNews = (
  newsItem,
  usedIds,
  allCategoryNews,
  count = 1
) => {
  const relatedMap = new Map();

  const filterAndAdd = (list) => {
    for (const item of list) {
      // নিজের news বাদ
      if (item.id === newsItem.id) continue;

      // ৬টা opened news + আগের related news বাদ
      if (usedIds.has(item.id)) continue;

      // duplicate বাদ
      if (relatedMap.has(item.id)) continue;

      relatedMap.set(item.id, item);

      if (relatedMap.size >= count) break;
    }
  };

  // ১. একই subcategory
  if (newsItem.subcategory) {
    const targetSubcategory =
      newsItem.subcategory.trim().toLowerCase();

    const subMatched = allCategoryNews.filter(item =>
      item.subcategory &&
      item.subcategory.trim().toLowerCase() ===
        targetSubcategory
    );

    filterAndAdd(subMatched);
  }

  // ২. একই tag
  if (
    relatedMap.size < count &&
    Array.isArray(newsItem.tags) &&
    newsItem.tags.length > 0
  ) {
    const targetTags = newsItem.tags.map(tag =>
      String(tag).trim().toLowerCase()
    );

    const tagMatched = allCategoryNews.filter(item =>
      Array.isArray(item.tags) &&
      item.tags.some(tag =>
        targetTags.includes(
          String(tag).trim().toLowerCase()
        )
      )
    );

    filterAndAdd(tagMatched);
  }

  // ৩. একই category — শেষ fallback
  if (
    relatedMap.size < count &&
    newsItem.category
  ) {
    const catMatched = allCategoryNews.filter(
      item =>
        item.category === newsItem.category
    );

    filterAndAdd(catMatched);
  }

  return Array.from(relatedMap.values()).slice(
    0,
    count
  );
};
 
 
useEffect(() => {
  const fetchNews = async () => {
    try {
      const docRef = doc(db, "news", id);
      const snap = await getDoc(docRef);

      if (!snap.exists()) return;

      const data = {
        id: snap.id,
        ...snap.data()
      };

      setOpenedNews(prev => {
        const exists = prev.some(
          item => item.id === data.id
        );

        if (exists) {
          return prev;
        }

        return [...prev, data];
      });

      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });

    } catch (error) {
      console.error(
        "Error fetching opened news:",
        error
      );
    }
  };

  fetchNews();
}, [id]);
  
 

// সব useEffect ডিলিট করে শুধু এই একটি রাখুন
useEffect(() => {
  const fetchAllData = async () => {
    const docRef = doc(db, "news", id);
    const snap = await getDoc(docRef);

const now = new Date();

const today =
  now.getFullYear() +
  "-" +
  String(now.getMonth() + 1).padStart(2, "0") +
  "-" +
  String(now.getDate()).padStart(2, "0");

try {
  await updateDoc(docRef, {
    views: increment(1),
  });

  await setDoc(
    doc(db, "site_stats", "visitors"),
    {
      [`${today}-news`]: increment(1),
    },
    { merge: true }
  );
} catch (e) {
  console.error(e);
}

    if (snap.exists()) {
      const newsData = { id: snap.id, ...snap.data() };
      setNews(newsData);

      // Related news
      const q = query(
        collection(db, "news"),
        where("category", "==", newsData.category),
        limit(6)
      );
	  

    const querySnapshot = await getDocs(q);

const related = querySnapshot.docs
  .filter(doc => doc.id !== id)
  .map(doc => ({
    id: doc.id,
    ...doc.data()
  }))
  .slice(0, 2);

setRelatedNews(related);

// Current news + একই category-এর ৫টি news
setOpenedNews(() => {
  return [
    newsData,
    ...related
  ].slice(0, 3);
});
	  
	 
	  
      window.scrollTo(0, 0);
    }
  };

  fetchAllData();
}, [id]);

useEffect(() => {
  const buildInlineNews = async () => {
    if (!openedNews.length) {
      setInlineNewsMap({});
      return;
    }

    const newInlineMap = {};

    // বর্তমানে opened 3টি news কখনো নিজেরা related হবে না
    const openedIds = new Set(
      openedNews.map(item => item.id)
    );

    // পুরো page-এ কোনো related news একবারের বেশি ব্যবহার হবে না
    const globallyUsedRelatedIds = new Set(
      openedIds
    );

    for (const opened of openedNews) {

      const paragraphs = (opened.content || "")
        .split(/\r?\n/)
        .filter(p => p.trim() !== "");

      // শেষ paragraph-এর পরে related লাগবে না
      // তাই 7 paragraph = 3, 8 paragraph = 3
      const requiredCount = Math.floor(
        (paragraphs.length - 1) / 2
      );

      if (requiredCount <= 0) {
        newInlineMap[opened.id] = [];
        continue;
      }

      let candidates = [];

      try {
        // Current news-এর category থেকে candidate আনবে
        const q = query(
          collection(db, "news"),
          where("category", "==", opened.category),
          limit(100)
        );

        const snapshot = await getDocs(q);

        candidates = snapshot.docs
          .map(docSnap => ({
            id: docSnap.id,
            ...docSnap.data()
          }))
          .filter(item =>
            !openedIds.has(item.id) &&
            !globallyUsedRelatedIds.has(item.id)
          );

      } catch (error) {
        console.error(
          "Inline related fetch error:",
          error
        );
      }

      const related = [];

      // =====================================
      // 1. SAME SUBCATEGORY
      // =====================================

      if (opened.subcategory) {
        const currentSubcategory =
          String(opened.subcategory)
            .trim()
            .toLowerCase();

        for (const item of candidates) {

          if (related.length >= requiredCount) {
            break;
          }

          if (!item.subcategory) continue;

          const itemSubcategory =
            String(item.subcategory)
              .trim()
              .toLowerCase();

          if (
            itemSubcategory === currentSubcategory &&
            !globallyUsedRelatedIds.has(item.id)
          ) {
            related.push(item);
            globallyUsedRelatedIds.add(item.id);
          }
        }
      }

      // =====================================
      // 2. SAME TAG
      // =====================================

      if (
        related.length < requiredCount &&
        Array.isArray(opened.tags) &&
        opened.tags.length > 0
      ) {

        const currentTags = opened.tags.map(tag =>
          String(tag)
            .trim()
            .toLowerCase()
        );

        for (const item of candidates) {

          if (related.length >= requiredCount) {
            break;
          }

          if (
            globallyUsedRelatedIds.has(item.id) ||
            !Array.isArray(item.tags)
          ) {
            continue;
          }

          const hasMatchingTag = item.tags.some(tag =>
            currentTags.includes(
              String(tag)
                .trim()
                .toLowerCase()
            )
          );

          if (hasMatchingTag) {
            related.push(item);
            globallyUsedRelatedIds.add(item.id);
          }
        }
      }

      // =====================================
      // 3. FALLBACK
      // =====================================

      if (related.length < requiredCount) {

        for (const item of candidates) {

          if (related.length >= requiredCount) {
            break;
          }

          if (
            !globallyUsedRelatedIds.has(item.id)
          ) {
            related.push(item);
            globallyUsedRelatedIds.add(item.id);
          }
        }
      }

      newInlineMap[opened.id] = related;
    }

    console.log(
      "FINAL INLINE MAP:",
      newInlineMap
    );

    setInlineNewsMap(newInlineMap);
  };

  buildInlineNews();
}, [openedNews]);

  if (!news) {
    return (
      <div className="mobile-news-loading">
        লোড হচ্ছে...
      </div>
    );
  }


const renderShareButtons = (item) => (
  <div className="mobile-news-share">
    <span className="mobile-news-share-label">
      শেয়ার করুন:
    </span>

    <div className="mobile-news-share-icons">

      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`}
        target="_blank"
        rel="noopener noreferrer"
        title="Facebook এ শেয়ার করুন"
        style={{ backgroundColor: "#1877F2" }}
      >
        <FaFacebookF />
      </a>

      <a
        href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}&text=${encodeURIComponent(item.title)}`}
        target="_blank"
        rel="noopener noreferrer"
        title="X এ শেয়ার করুন"
        style={{ backgroundColor: "#000000" }}
      >
        <FaXTwitter />
      </a>

      <a
        href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
          item.title + " - " + window.location.href
        )}`}
        target="_blank"
        rel="noopener noreferrer"
        title="WhatsApp এ শেয়ার করুন"
        style={{ backgroundColor: "#25D366" }}
      >
        <FaWhatsapp />
      </a>

      <a
        href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(window.location.href)}&title=${encodeURIComponent(item.title)}`}
        target="_blank"
        rel="noopener noreferrer"
        title="LinkedIn এ শেয়ার করুন"
        style={{ backgroundColor: "#0A66C2" }}
      >
        <FaLinkedinIn />
      </a>

      <a
        href={`https://t.me/share/url?url=${encodeURIComponent(
          window.location.href
        )}&text=${encodeURIComponent(item.title)}`}
        target="_blank"
        rel="noopener noreferrer"
        title="Telegram এ শেয়ার করুন"
        style={{ backgroundColor: "#229ED9" }}
      >
        <FaTelegramPlane />
      </a>

    </div>
  </div>
);




  return (
    <div className="mobile-news-details">

<div className="mobile-news-category">
  <Link
    to={`/category/${encodeURIComponent(
      news.categorySlug || "general"
    )}`}
  >
    {news.category}
  </Link>
</div>

<h1 className="mobile-news-title">
  {news.title}
</h1>

{renderShareButtons(news)}


      <div className="mobile-reporter">
        <span>
          {news.reporterName || ""}
        </span>
      </div>

      <div className="mobile-news-meta">

        <span>
          <FaCalendarAlt />
          {news.timestamp
            ? new Date(
                news.timestamp.seconds * 1000
              ).toLocaleDateString(
                "bn-BD",
                {
                  day: "2-digit",
                  month: "long",
                  year: "numeric"
                }
              )
            : "তারিখ নেই"}
        </span>

        <span>
          <FaClock />
          {news.timestamp
            ? new Date(
                news.timestamp.seconds * 1000
              ).toLocaleTimeString(
                "bn-BD",
                {
                  hour: "2-digit",
                  minute: "2-digit"
                }
              )
            : "সময় নেই"}
        </span>

      </div>

      <img
        src={news.image}
        alt={news.title}
        className="mobile-news-image"
      />

      {news.caption && (
        <p className="mobile-caption">
          {news.caption}
        </p>
      )}

{console.log(
  "RENDER CURRENT:",
  news?.id,
  "INLINE:",
  inlineNewsMap[news?.id]
)}

<div className="mobile-news-content">

  {openedNews.slice(0, 3).map((item) => {

    const paragraphs = (item.content || "")
      .split(/\r?\n/)
      .filter(p => p.trim() !== "");

    const relatedList =
      inlineNewsMap[item.id] || [];

    return (
     <React.Fragment key={item.id}>

  {item.id !== news.id && (
    <>
      {/* NEWS SEPARATOR */}
      <div className="mobile-news-separator">
        <span>পরবর্তী সংবাদ</span>
      </div>

      <h2 className="mobile-opened-news-title">
        {item.title}
      </h2>

      {renderShareButtons(item)}

      {item.image && (
        <img
          src={item.image}
          alt={item.title}
          className="mobile-opened-news-image"
        />
      )}
    </>
  )}

      {paragraphs.map((paragraph, index) => {
  const relatedIndex = Math.floor(index / 2);
  const inlineItem = relatedList[relatedIndex];

  return (
    <React.Fragment key={`${item.id}-${index}`}>

      <p
        style={{
          textAlign: "justify",
          lineHeight: "1.8",
          marginBottom: "20px",
          fontSize: "17px",
          color: "#333",
        }}
      >
        {paragraph}
      </p>

      {/* প্রতি ২ paragraph পর related link */}
     {(index + 1) % 2 === 0 &&
  index < paragraphs.length - 1 &&
  inlineItem && (
    <Link
  to={`/${encodeURIComponent(inlineItem.category)}/${encodeURIComponent(inlineItem.subcategory || "all")}/${inlineItem.id}`}
  style={{
    display: "block",
    margin: "15px 0 20px",
    padding: "8px 10px",
    border: "1px solid #eee",
    borderLeft: "4px solid #d2202a",
    borderRadius: "6px",
    background: "#fafafa",
    textDecoration: "none",
    transition: "all 0.2s ease",
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.borderColor = "#4169E1";
    e.currentTarget.style.borderLeftColor = "#4169E1";
    e.currentTarget.style.background = "#f5f7ff";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.borderColor = "#eee";
    e.currentTarget.style.borderLeftColor = "#d2202a";
    e.currentTarget.style.background = "#fafafa";
  }}
>
  <div
    style={{
      fontSize: "12px",
      color: "#d2202a",
      fontWeight: "bold",
      marginBottom: "7px",
    }}
  >
    আরও পড়ুন
  </div>

  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "10px",
    }}
  >
    {inlineItem.image && (
      <img
        src={inlineItem.image}
        alt={inlineItem.title}
        style={{
          width: "85px",
          height: "58px",
          objectFit: "cover",
          borderRadius: "4px",
          flexShrink: 0,
        }}
      />
    )}

    <div
      style={{
        flex: 1,
        color: "#222",
        fontSize: "15px",
        fontWeight: "600",
        lineHeight: "1.4",
        textAlign: "justify",
      }}
    >
      {inlineItem.title}
    </div>
  </div>
</Link>
  )}

    </React.Fragment>
  );
})}

<div
  style={{
    color: "#d2202a",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "5px",
    margin: "10px 0 20px",
  }}
>
  <span>👁</span>
  <span>
    {item.views || 0} বার পঠিত
  </span>
</div>
<Comments newsId={item.id} />
      </React.Fragment>
    );
  })}

</div>





{news.tags && news.tags.length > 0 && (
  <div
    style={{
      marginTop: "25px",
      marginBottom: "30px",
      paddingTop: "15px",
      borderTop: "1px solid #ddd",
    }}
  >
    <strong style={{ display: "block", marginBottom: "12px" }}>
      কী-ওয়ার্ড
    </strong>

    {news.tags.map((tag, index) => (
      <Link
        key={index}
        to={`/tag/${encodeURIComponent(tag)}`}
        style={{
          display: "inline-block",
          marginRight: "8px",
          marginBottom: "8px",
          padding: "7px 12px",
          background: "#f3f3f3",
          color: "#333",
          textDecoration: "none",
          borderRadius: "18px",
          fontSize: "14px",
        }}
      >
        {tag}
      </Link>
    ))}
  </div>
)}

     

    </div>
  );
};

export default MobileNewsDetails;